(function () {
  const section = document.querySelector('[data-aftercare-section]');
  if (!section) return;

  const grid = section.querySelector('[data-aftercare-grid]');
  const cards = Array.from(section.querySelectorAll('[data-aftercare-card]'));
  const searchInput = section.querySelector('[data-aftercare-search]');
  const counter = section.querySelector('[data-aftercare-count]');
  const featured = section.querySelector('[data-aftercare-featured]');
  const filterSelects = Array.from(section.querySelectorAll('[data-aftercare-filter]'));

  const state = {
    query: '',
    filters: {},
  };

  filterSelects.forEach((select) => {
    const name = select.dataset.aftercareFilter;
    state.filters[name] = '';
    select.addEventListener('change', () => {
      state.filters[name] = select.value.toLowerCase();
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      state.query = searchInput.value.trim().toLowerCase();
      applyFilters();
    });
  }

  function applyFilters() {
    let visible = 0;

    cards.forEach((card) => {
      const title = card.dataset.title || '';
      const materials = (card.dataset.material || '').split('|').filter(Boolean);
      const cares = (card.dataset.care || '').split('|').filter(Boolean);

      const matchesQuery = !state.query || title.includes(state.query);
      const matchesMaterial = !state.filters.material || materials.includes(state.filters.material);
      const matchesCare = !state.filters.care || cares.includes(state.filters.care);

      const show = matchesQuery && matchesMaterial && matchesCare;
      card.classList.toggle('is-hidden', !show);
      if (show) visible += 1;
    });

    if (counter) counter.textContent = visible;
    if (featured) featured.classList.toggle('is-hidden', visible === 0);
    if (grid) grid.classList.toggle('is-empty', visible === 0);
  }
})();
